export default "__VITE_ASSET__CcOHNHjx__"